export default "__VITE_ASSET__CpjAGQE8__";